import React from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Input, Button, Checkbox } from 'semantic-ui-react';
import { changeDocTitle } from '../../../components/helpers';
import ReportButton from '../../../containers/admin/ReportButton';
import queryString from 'query-string';
import experienceService from '../../../services/api/experienceService';
import { NewVolunteersRowDef } from '../../../components/common/rows/NewVolunteersRow';
import AGTable from '../../../components/table/aggrid';
import { AdminTableSection, AdminTableContent } from 'src/assets/styles/components/AdminTable';

const AllNewVolunteers = (props) => {
  const [volunteers, set_volunteers] = React.useState([]);
  const [loaded, set_loaded] = React.useState(false);
  const [showVolunteer, set_showVolunteer] = React.useState(null);
  const [inputs, setInputs] = React.useState({});

  let query = props.location.search;
  let parsedQueryString = queryString.parse(query);

  React.useEffect(() => getInfo(), [inputs.noVolunteer, inputs.showSecondInterview]);

  React.useEffect(() => {
    changeDocTitle('Futuros Voluntarios');
  }, []);

  const onEnter = (e) => {
    if (e.key === 'Enter') getInfo();
  };

  function getInfo(page = false) {
    set_loaded(false);

    const { noVolunteer, showSecondInterview } = inputs;

    let body = {
      keyword: inputs.keyword || parsedQueryString.keyword,
      noVolunteer,
      showSecondInterview: !!showSecondInterview,
    };

    experienceService
      .allNewVolunteers({ body })
      .then((response) => {
        if (response.data.success) {
          set_loaded(true);
          props.history.push('?keyword=');
          set_volunteers(response.data.volunteers);
        } else {
          set_loaded(null);
        }
      })
      .catch((error) => {
        if (error.response) Swal.fire(error.response.data.message);
        set_loaded(false);
      });
  }

  return (
    <AdminTableSection>
      <>
        <AdminTableContent>
          <div>
            <Button primary onClick={() => getInfo()}>
              Recargar
            </Button>
            <Button secondary onClick={() => props.history.push('/nuevo-voluntario')}>
              Inscribir
            </Button>
          </div>
          <div style={{ display: 'block', width: '100%', margin: '20px  0' }}>
            <label
              style={{ display: 'block', margin: '35px 0 0 0', fontWeight: 'bold' }}
              htmlFor="keyword"
            >
              Buscar
            </label>
            <Input
              loading={!loaded}
              name={'keyword'}
              id={'keyword'}
              onChange={(e) => setInputs({ ...inputs, keyword: e.target.value })}
              value={inputs.keyword}
              onKeyPress={onEnter}
              style={{ width: '45%' }}
              placeholder="Buscar..."
            />
          </div>
        </AdminTableContent>
        <div style={{ display: 'block', width: '100%', margin: '20px  0' }}>
          <label
            style={{ display: 'block', margin: '15px 0 0 0', fontWeight: 'bold' }}
            htmlFor="noVolunteer"
          >
            Filtrar por aspirantes aún no voluntarios
          </label>
          <label style={{ padding: '0 15px 0 0' }} htmlFor="noVolunteer">
            Pendientes
          </label>
          <Checkbox
            label="Ver todos"
            id="noVolunteer"
            name="noVolunteer"
            checked={inputs.noVolunteer}
            toggle
            onClick={() => setInputs({ ...inputs, noVolunteer: !inputs.noVolunteer })}
          />
        </div>
        <p>Total en pantalla: {volunteers.length}</p>
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <ReportButton
            URL={`/experience/NewVolunteersReport?noVolunteer=${!!inputs.noVolunteer}&showSecondInterview=${!!inputs.showSecondInterview}`}
            fileName={`reporte_nuevos_voluntarios.xlsx`}
            event="Descargar Reporte"
          />
          <Button
            primary={!inputs.showSecondInterview}
            onClick={() =>
              setInputs({ ...inputs, showSecondInterview: !inputs.showSecondInterview })
            }
          >
            {inputs.showSecondInterview ? 'Ocultar 2da entrevista' : 'Ver 2da entrevista'}
          </Button>
        </div>
      </>
      <AGTable
        rowData={volunteers}
        rowHeight={90}
        columnDefs={NewVolunteersRowDef({
          set_showVolunteer,
          showVolunteer,
          getInfo,
          showSecondInterview: !!inputs.showSecondInterview,
        })}
        suppressDragLeaveHidesColumns={false}
      />
    </AdminTableSection>
  );
};

export default AllNewVolunteers;
